import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React from 'react';
import { Button } from '@lyse-as/formds-react';

import { Link } from 'src/components/link';
import { config } from 'src/config/config';
import { useSubmitShoppingCartMutation } from 'src/hooks/use-submit-shopping-cart-mutation';
import { DeliveryInformation } from 'src/pages/summary/delivery-information';
import { PaymentInformation } from 'src/pages/summary/payment-information';
import { ProductsSummary } from 'src/pages/summary/products-summary';
import { i18n } from 'src/i18n';
import { I18nUtils } from 'src/utils/i18n-utils';

import { StyledButtonContainer, StyledHeading, StyledTerms } from './summary-page-content.styled';

export const SummaryPageContent = () => {
  const { submitShoppingCart } = useSubmitShoppingCartMutation();

  return (
    <>
      <StyledHeading component="h1" variant="headline2">
        {i18n.page.summary.title}
      </StyledHeading>
      <ProductsSummary />
      <PaymentInformation />
      <DeliveryInformation />
      <StyledButtonContainer>
        <Button onClick={submitShoppingCart}>{i18n.page.summary.submitButton}</Button>
      </StyledButtonContainer>
      <StyledTerms component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
        {I18nUtils.richMessage(i18n.page.summary.terms, {
          termsLinkText: (
            <Link href={config.TERMSLINK} variant="paragraph3" target="_blank">
              {i18n.page.summary.linkToTerms}
            </Link>
          ),
        })}
      </StyledTerms>
    </>
  );
};
